  var advance = function advance() {
    if(typeof quickAddButton == 'function'){
    }
    if(typeof restoreState == 'function'){
      restoreState();
    }

    $th_refreshWishlistItems();







  


    
    
// Add a single event listener for each `.pd-quick-view` container
// document.querySelectorAll('.pd-quick-view').forEach(function(container) {
//   container.addEventListener('click', function() {
//     // Toggle the 'active' class on the clicked .pd-quick-view container
//     if (container.classList.contains('active')) {
//       container.classList.remove('active');
//     } else {
//       // Remove 'active' class from all .pd-quick-view elements
//       document.querySelectorAll('.pd-quick-view').forEach(view => {
//         view.classList.remove('active');
//       });
//       container.classList.add('active');
//     }
//   });
// });



  }
  var infinitescroll = {
    scolljs: function(){
      var endlessScroll = new Ajaxinate({
        container: '#product-grid',
        pagination: '#AjaxinatePagination',
        //loadingText: document.getElementById('AjaxinatePagination').dataset.text,
        callback: advance,
        offset: 400
      });
    }
  }
  infinitescroll.scolljs();
  document.addEventListener('scroll', function(e) {
  	var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
	sessionStorage.scrollPos = document.documentElement.scrollTop;
	sessionStorage.totalpage = totalpage;
  });
  if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
	var scrollTop=sessionStorage?.getItem('scrollPos')
	document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
    window.scrollTo(0,0);
	scrollManualy(scrollTop);
	function scrollManualy(scrollTop){
		scrollTop = parseInt(scrollTop);
		window.scrollTo(0,scrollTop)
 		setTimeout(function(){
			if(window.scrollY < scrollTop){
				scrollManualy(scrollTop)
			}
		},1000);
	 }
  }
$(document).on('click','.coll_read_more',function (e) {
  e.preventDefault();
  $('.collection-banner').addClass('active');
  $(this).hide();
  $('.coll_less').show();
});
$(document).on('click','.coll_less',function (e) {
  e.preventDefault();
  $('.collection-banner').removeClass('active');
  $(this).hide();
  $('.coll_read_more').show();
});
if($('.coll-descinr').height() > 60 ){
  $('.coll_read_more').show();
  $('.coll_less').show();
}else{
  $('.coll_read_more').hide();
  $('.coll_less').hide();
}

document.addEventListener('DOMContentLoaded', function() {
  const mobfilterSticky = document.querySelector('.mobfilter_sticky');
  const firstProductItem = document.querySelector('.collection-grid .product-item:first-of-type');
  let lastScrollTop = 0;
  let scrollTimeout;

  function checkPosition() {
      const rect = firstProductItem.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (rect.bottom <= viewportHeight) {
          mobfilterSticky.classList.add('visible');
      } else {
          mobfilterSticky.classList.remove('visible');
      }
  }

  function handleScroll() {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (currentScrollTop > lastScrollTop) {
          // Scrolling down
          mobfilterSticky.classList.remove('visible');
      } else {
          // Scrolling up
          checkPosition();
      }

      // Clear the previous timeout and set a new one
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
          // No scrolling for 2 seconds
          checkPosition();
      }, 2000);
      
      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
  }

  window.addEventListener('scroll', handleScroll);
  checkPosition();
});

function saveLoadedProducts() {
  var loadedProducts = document.querySelector("#product-grid").innerHTML;
  sessionStorage.setItem('loadedProducts', loadedProducts);
  var scrollPosition = window.scrollY;
  sessionStorage.setItem('scrollPosition', scrollPosition);
  sessionStorage.setItem('collectionURL', window.location.href);

  var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
  if (ajaxinatePagination) {
    sessionStorage.setItem('ajaxinateHref', ajaxinatePagination.href);
    sessionStorage.setItem('ajaxinatePage', ajaxinatePagination.dataset.page);
  }
}

function restoreState() {
  if (window.location.pathname.includes('/collections')) {
    
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    var loadedProducts = sessionStorage.getItem('loadedProducts');
    var collectionURL = sessionStorage.getItem('collectionURL');
    var ajaxinateHref = sessionStorage.getItem('ajaxinateHref');
    var ajaxinatePage = sessionStorage.getItem('ajaxinatePage');
    console.log(ajaxinateHref, ajaxinatePage);
    
    if (loadedProducts && collectionURL === window.location.href) {
      document.querySelector("#product-grid").innerHTML = loadedProducts;
      sessionStorage.removeItem('loadedProducts');
    }
    if (scrollPosition && collectionURL === window.location.href) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
    if (ajaxinateHref && ajaxinatePage && collectionURL === window.location.href) {
      var ajaxinatePagination = document.querySelector("#AjaxinatePagination a");
      if (ajaxinatePagination) {
        ajaxinatePagination.href = ajaxinateHref;
        ajaxinatePagination.dataset.page = ajaxinatePage;
      }
      sessionStorage.removeItem('ajaxinateHref');
      sessionStorage.removeItem('ajaxinatePage');
    }
  }
}

document.addEventListener('DOMContentLoaded', restoreState);

document.addEventListener('click', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

window.addEventListener('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});

document.querySelectorAll('.section-header a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    sessionStorage.clear();
  });
});

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    restoreState();
  }
});